/**
 * TOMOJO SUBSCRIPTION WIDGET - JavaScript
 * Gère les interactions du widget d'abonnement
 * Compatible avec les selling plans natifs Shopify
 */

(function() {
  'use strict';

  // Attendre le DOM
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initTomojoWidget);
  } else {
    initTomojoWidget();
  }

  function initTomojoWidget() {
    var widgets = document.querySelectorAll('.tomojo-widget');
    
    widgets.forEach(function(widget) {
      initWidget(widget);
    });
  }

  function initWidget(container) {
    // Récupérer les données produit (chercher dans plusieurs endroits)
    var productData = getProductData(container);
    
    if (!productData) {
      console.warn('Tomojo Widget: No product data found');
      return;
    }

    // Éléments DOM
    var variantCards = container.querySelectorAll('.tomojo-widget__variant-card');
    var purchaseOptions = container.querySelectorAll('.tomojo-widget__option');
    var subscriptionPanel = container.querySelector('.tomojo-widget__subscription-panel');
    var frequencySelect = container.querySelector('[data-frequency-select]');
    var sellingPlanInput = container.querySelector('[data-selling-plan-input]');
    var priceOnetime = container.querySelector('.tomojo-widget__price-onetime');
    var priceSubscription = container.querySelector('.tomojo-widget__price-subscription');

    // Éléments externes (bouton add to cart)
    var form = container.closest('form[action*="/cart/add"]') || document.querySelector('form[action*="/cart/add"]');
    var addToCartButton = form ? form.querySelector('.ProductForm__AddToCart') : null;
    var addToCartPriceEl = form ? form.querySelector('[data-add-to-cart-price]') : null;
    var quantityInput = form ? form.querySelector('.QuantitySelector__CurrentQuantity') : null;

    // État
    var state = {
      variantId: null,
      purchaseType: 'subscription',
      sellingPlanId: frequencySelect ? frequencySelect.value : null
    };

    // Initialiser variantId
    var selectedCard = container.querySelector('.tomojo-widget__variant-card.selected');
    if (selectedCard) {
      state.variantId = parseInt(selectedCard.dataset.variantId);
    } else if (productData && productData.variants && productData.variants.length > 0) {
      state.variantId = productData.variants[0].id;
    }

    // === FONCTIONS ===

    function getProductData(cont) {
      var jsonScript = null;
      
      // 1. Chercher à l'intérieur du widget
      jsonScript = cont.querySelector('[data-tomojo-product-json]');
      
      // 2. Chercher juste après le widget (sibling)
      if (!jsonScript && cont.nextElementSibling) {
        if (cont.nextElementSibling.hasAttribute && cont.nextElementSibling.hasAttribute('data-tomojo-product-json')) {
          jsonScript = cont.nextElementSibling;
        }
      }
      
      // 3. Chercher via le product-id
      if (!jsonScript) {
        var productId = cont.dataset.productId;
        if (productId) {
          jsonScript = document.querySelector('[data-tomojo-product-json][data-product-id="' + productId + '"]');
        }
      }
      
      // 4. Chercher n'importe où dans le document
      if (!jsonScript) {
        jsonScript = document.querySelector('[data-tomojo-product-json]');
      }

      // 5. Fallback: utiliser window.product si disponible
      if (!jsonScript && window.product) {
        console.log('Tomojo Widget: Using window.product');
        return {
          id: window.product.id,
          variants: window.product.variants,
          first_order_discount: 20,
          recurring_discount: 10
        };
      }
      
      if (!jsonScript) return null;
      
      try {
        return JSON.parse(jsonScript.textContent);
      } catch (e) {
        console.error('Tomojo Widget: Error parsing product data', e);
        return null;
      }
    }

    function getVariant(variantId) {
      if (!productData || !productData.variants) return null;
      for (var i = 0; i < productData.variants.length; i++) {
        if (productData.variants[i].id === variantId) {
          return productData.variants[i];
        }
      }
      return null;
    }

    function formatMoney(cents) {
      var amount = (cents / 100).toFixed(2).replace('.', ',');
      return amount + ' €';
    }

    function updatePricePerKg() {
      var variant = getVariant(state.variantId);
      if (!variant || !variant.weight) return;

      var weightKg = variant.weight / 1000;
      var price;

      if (state.purchaseType === 'subscription') {
        var planId = parseInt(state.sellingPlanId);
        var allocation = null;
        for (var i = 0; i < variant.selling_plan_allocations.length; i++) {
          if (variant.selling_plan_allocations[i].selling_plan_id === planId) {
            allocation = variant.selling_plan_allocations[i];
            break;
          }
        }
        price = allocation ? allocation.per_delivery_price : variant.price;
      } else {
        price = variant.price;
      }

      var pricePerKg = (price / 100) / weightKg;

      variantCards.forEach(function(card) {
        var priceKgEl = card.querySelector('.tomojo-widget__variant-price-kg');
        if (!priceKgEl) return;

        var cardVariantId = parseInt(card.dataset.variantId);
        var cardVariant = getVariant(cardVariantId);
        if (!cardVariant || !cardVariant.weight) return;

        var cardWeightKg = cardVariant.weight / 1000;
        var cardPrice;

        if (state.purchaseType === 'subscription') {
          var planId = parseInt(state.sellingPlanId);
          var cardAllocation = null;
          for (var i = 0; i < cardVariant.selling_plan_allocations.length; i++) {
            if (cardVariant.selling_plan_allocations[i].selling_plan_id === planId) {
              cardAllocation = cardVariant.selling_plan_allocations[i];
              break;
            }
          }
          cardPrice = cardAllocation ? cardAllocation.per_delivery_price : cardVariant.price;
        } else {
          cardPrice = cardVariant.price;
        }

        var cardPricePerKg = (cardPrice / 100) / cardWeightKg;
        priceKgEl.textContent = cardPricePerKg.toFixed(2) + '€/kg';
      });
    }

    function updatePrices() {
      var variant = getVariant(state.variantId);
      if (!variant) return;

      var basePrice = variant.price;
      var firstOrderDiscount = productData.first_order_discount || 20;
      var firstOrderPrice = Math.round(basePrice * (1 - firstOrderDiscount / 100));

      // Prix achat unique dans le widget
      if (priceOnetime) {
        priceOnetime.textContent = formatMoney(basePrice);
      }

      // Prix abonnement dans le widget
      if (priceSubscription) {
        var originalPriceEl = priceSubscription.querySelector('.tomojo-widget__original-price');
        var discountedPriceEl = priceSubscription.querySelector('.tomojo-widget__discounted-price');
        
        if (originalPriceEl) {
          originalPriceEl.textContent = formatMoney(basePrice);
        }
        if (discountedPriceEl) {
          discountedPriceEl.textContent = formatMoney(firstOrderPrice);
        }
      }

      // Prix dans le bouton Add to Cart
      updateAddToCartPrice(basePrice, firstOrderPrice);
      updatePricePerKg();
    }

    function updateAddToCartPrice(basePrice, firstOrderPrice) {
      if (!addToCartPriceEl) return;

      var quantity = quantityInput ? parseInt(quantityInput.value) || 1 : 1;
      var unitPrice = state.purchaseType === 'subscription' ? firstOrderPrice : basePrice;
      var totalPrice = unitPrice * quantity;
      
      addToCartPriceEl.textContent = formatMoney(totalPrice);

      // Mettre à jour les data attributes sur le bouton
      if (addToCartButton) {
        addToCartButton.dataset.basePrice = basePrice;
        addToCartButton.dataset.subscriptionPrice = firstOrderPrice;
        addToCartButton.dataset.quantity = quantity;
      }
    }

    function updateSellingPlanInput() {
      if (!sellingPlanInput) return;

      if (state.purchaseType === 'subscription' && state.sellingPlanId) {
        sellingPlanInput.value = state.sellingPlanId;
      } else {
        sellingPlanInput.value = '';
      }

      sellingPlanInput.dispatchEvent(new Event('change', { bubbles: true }));
    }

    function syncVariantToForm() {
      if (!form) return;

      var variantInput = form.querySelector('input[name="id"], select[name="id"]');
      if (variantInput && variantInput.value != state.variantId) {
        variantInput.value = state.variantId;
        variantInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }

    function selectVariant(variantId, external) {
      if (state.variantId === variantId) return;
      
      state.variantId = variantId;

      variantCards.forEach(function(card) {
        card.classList.toggle('selected', parseInt(card.dataset.variantId) === variantId);
      });

      updatePrices();

      if (!external) {
        syncVariantToForm();
      }
    }

    function selectPurchaseType(type) {
      if (state.purchaseType === type) return;
      
      state.purchaseType = type;

      purchaseOptions.forEach(function(option) {
        option.classList.toggle('selected', option.dataset.type === type);
      });

      if (subscriptionPanel) {
        subscriptionPanel.classList.toggle('visible', type === 'subscription');
      }

      updateSellingPlanInput();
      updatePricePerKg();
      
      // Mettre à jour le prix du bouton Add to Cart
      var variant = getVariant(state.variantId);
      if (variant) {
        var basePrice = variant.price;
        var firstOrderDiscount = productData.first_order_discount || 20;
        var firstOrderPrice = Math.round(basePrice * (1 - firstOrderDiscount / 100));
        updateAddToCartPrice(basePrice, firstOrderPrice);
      }
    }

    function selectFrequency(planId) {
      state.sellingPlanId = planId;
      updateSellingPlanInput();
      updatePricePerKg();
    }

    // === BINDING ÉVÉNEMENTS ===

    // Sélection variante
    variantCards.forEach(function(card) {
      card.addEventListener('click', function(e) {
        e.preventDefault();
        console.log('Variant card clicked:', this.dataset.variantId);
        selectVariant(parseInt(this.dataset.variantId), false);
      });
    });

    // Sélection type d'achat
    purchaseOptions.forEach(function(option) {
      option.addEventListener('click', function(e) {
        e.preventDefault();
        console.log('Purchase option clicked:', this.dataset.type);
        selectPurchaseType(this.dataset.type);
      });
    });

    // Changement de fréquence
    if (frequencySelect) {
      frequencySelect.addEventListener('change', function() {
        console.log('Frequency changed:', this.value);
        selectFrequency(this.value);
      });
    }

    // Changement de quantité
    if (quantityInput) {
      // Écouter les changements sur l'input
      quantityInput.addEventListener('change', function() {
        console.log('Quantity changed:', this.value);
        var variant = getVariant(state.variantId);
        if (variant) {
          var basePrice = variant.price;
          var firstOrderDiscount = productData.first_order_discount || 20;
          var firstOrderPrice = Math.round(basePrice * (1 - firstOrderDiscount / 100));
          updateAddToCartPrice(basePrice, firstOrderPrice);
        }
      });

      // Observer les clics sur les boutons +/- du quantity selector
      var quantityWrapper = quantityInput.closest('.QuantitySelector');
      if (quantityWrapper) {
        quantityWrapper.addEventListener('click', function(e) {
          // Petit délai pour laisser le temps à la valeur de se mettre à jour
          setTimeout(function() {
            var variant = getVariant(state.variantId);
            if (variant) {
              var basePrice = variant.price;
              var firstOrderDiscount = productData.first_order_discount || 20;
              var firstOrderPrice = Math.round(basePrice * (1 - firstOrderDiscount / 100));
              updateAddToCartPrice(basePrice, firstOrderPrice);
            }
          }, 50);
        });
      }
    }

    // Écouter les changements de variantes externes
    document.addEventListener('variant:changed', function(e) {
      if (e.detail && e.detail.variant) {
        selectVariant(e.detail.variant.id, true);
      }
    });

    // Observer le formulaire produit
    if (form) {
      var variantInput = form.querySelector('input[name="id"], select[name="id"]');
      if (variantInput) {
        variantInput.addEventListener('change', function() {
          selectVariant(parseInt(this.value), true);
        });

        if (variantInput.type === 'hidden') {
          var observer = new MutationObserver(function(mutations) {
            mutations.forEach(function(mutation) {
              if (mutation.type === 'attributes' && mutation.attributeName === 'value') {
                selectVariant(parseInt(variantInput.value), true);
              }
            });
          });
          
          observer.observe(variantInput, { attributes: true });
        }

        // Sync initial
        if (variantInput.value) {
          selectVariant(parseInt(variantInput.value), true);
        }
      }
    }

    // === INITIALISATION ===
    updatePrices();
    updateSellingPlanInput();

    console.log('Tomojo Widget initialized', { 
      productId: productData.id, 
      variantId: state.variantId,
      variantCards: variantCards.length,
      purchaseOptions: purchaseOptions.length,
      addToCartButton: !!addToCartButton
    });
  }

})();
